import React from 'react';

import { BaseIcon } from '@/shared/assets/icons/base-icon/base-icon';
import { TBaseIcon } from '@/shared/assets/icons/base-icon/base-icon.types';

export const VaultIcon: React.FC<TBaseIcon> = (props) => {
  return (
    <BaseIcon
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      {...props}
    >
      <path
        d="M4.32042 29.0194C3.69525 29.6443 3.34394 30.4921 3.34375 31.376V34.996C3.34375 35.4381 3.51934 35.862 3.83191 36.1745C4.14447 36.4871 4.56839 36.6627 5.01042 36.6627H10.0104C10.4524 36.6627 10.8764 36.4871 11.1889 36.1745C11.5015 35.862 11.6771 35.4381 11.6771 34.996V33.3294C11.6771 32.8873 11.8527 32.4634 12.1652 32.1509C12.4778 31.8383 12.9017 31.6627 13.3437 31.6627H15.0104C15.4524 31.6627 15.8764 31.4871 16.1889 31.1745C16.5015 30.862 16.6771 30.4381 16.6771 29.996V28.3294C16.6771 27.8873 16.8527 27.4634 17.1652 27.1509C17.4778 26.8383 17.9017 26.6627 18.3437 26.6627H18.6304C19.5144 26.6625 20.3621 26.3112 20.9871 25.686L22.3437 24.3294C24.6601 25.1363 27.1818 25.1332 29.4962 24.3206C31.8106 23.508 33.7808 21.9341 35.0843 19.8562C36.3879 17.7784 36.9478 15.3197 36.6723 12.8823C36.3968 10.4449 35.3023 8.17312 33.5678 6.43865C31.8333 4.70418 29.5616 3.60967 27.1242 3.33418C24.6868 3.05869 22.2281 3.61853 20.1502 4.9221C18.0724 6.22568 16.4984 8.19582 15.6858 10.5102C14.8733 12.8246 14.8702 15.3463 15.6771 17.6627L4.32042 29.0194Z"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.25 14.9922C26.9404 14.9922 27.5 14.4325 27.5 13.7422C27.5 13.0518 26.9404 12.4922 26.25 12.4922C25.5596 12.4922 25 13.0518 25 13.7422C25 14.4325 25.5596 14.9922 26.25 14.9922Z"
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  );
};

VaultIcon.displayName = 'VaultIcon';
